<template>
    <b :class="{top}"><slot></slot></b>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class InfoHeader extends Vue {
        @Prop({type: Boolean}) top!: boolean;
    }
</script>

<style lang="scss" scoped>
    b {
        grid-column: 1;

        &.top {
            align-self: start;
        }
    }
</style>
